import moment from "moment";
import StarRating from "../components/RatingStar";
import { Button } from "primereact/button";
import { FaReply } from "react-icons/fa";
import { BiSolidHide } from "react-icons/bi";
import Description from "../components/Description/Description";

export const StoreColumns = [
  {
    field: "createdAt",
    header: "Date",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "createdAt")} className="">
          <p className="w-[6rem]">
            {moment(row?.createdAt).utc().format("DD MMM YYYY hh:mma")}
          </p>
        </div>
      </>
    ),
  },
  {
    field: "user",
    header: "Customer",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "user")} className="">
          <p className="w-[6rem]">
            {row?.user?.first_name || ""} {row?.user?.last_name || ""}
          </p>
        </div>
      </>
    ),
  },
  {
    field: "rating",
    header: "Rating",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "user")} className="">
          <p className="w-[6rem]">
            <StarRating stars={row?.rating} />
          </p>
        </div>
      </>
    ),
  },
  {
    field: "review",
    header: "Review",
    accessor: (row, handleCellClick) => {
      return (
        <>
          <div
            onClick={() => handleCellClick(row, "review")}
            className="h-5 line-clamp-2"
          >
            <p className="w-[6rem]">{row?.review || ""}</p>
          </div>
        </>
      );
    },
  },
  {
    field: "vendorReply",
    header: "Vendor Reply",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "vendorReply")} className="">
          {row?.vendorReply ? (
            <div className="bg-gray-100 p-2 rounded w-[10rem]">
              <p className="font-medium line-clamp-2">{row.vendorReply}</p>
              {row.replyDate && (
                <p className="text-xs text-gray-500">
                  {moment(row.replyDate).utc().format("DD MMM YYYY")}
                </p>
              )}
            </div>
          ) : (
            <span className="text-gray-400">No reply yet</span>
          )}
        </div>
      </>
    ),
  },
  {
    field: "actions",
    header: "Actions",
    accessor: (row, handleCellClick) => (
      <div className="flex gap-2">
        <Button
          icon="pi pi-reply"
          className="p-button-sm p-button-text"
          tooltip="Reply to review"
          tooltipOptions={{ position: 'top' }}
          onClick={(e) => {
            e.stopPropagation();
            handleCellClick(row, "replyAction");
          }}
        />
        <Button
          icon="pi pi-eye-slash"
          className="p-button-sm p-button-text p-button-danger"
          tooltip="Hide review"
          tooltipOptions={{ position: 'top' }}
          onClick={(e) => {
            e.stopPropagation();
            handleCellClick(row, "hideAction");
          }}
        />
      </div>
    ),
  }
];

export const StoresearchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

export const Storefilters = [
  {
    filterType: "Rating",
    inputName: "rating",
    options: [
      {
        name: "5",
        code: "5",
      },
      {
        name: "4",
        code: "4",
      },
      {
        name: "3",
        code: "3",
      },
      {
        name: "2",
        code: "2",
      },
      {
        name: "1",
        code: "1",
      },
    ],
  },
  {
    filterType: "Reply Status",
    inputName: "replyStatus",
    options: [
      {
        name: "With Reply",
        code: "With Reply",
      },
      {
        name: "Without Reply",
        code: "Without Reply",
      },
    ],
  },
];

export const StorecanlenderFilter = {
  filterType: "Review Date",
  inputName: "createdAt",
  maxDate: new Date(),
};

export const ProductColumns = [
  {
    field: "createdAt",
    header: "Date",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "createdAt")} className="">
          <p className="w-[6rem]">
            {moment(row?.createdAt).utc().format("DD-MM-YYYY")}
          </p>
        </div>
      </>
    ),
  },
  {
    field: "user",
    header: "Customer",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "user")} className="">
          <p className="w-full">
            {row?.user?.first_name || ""} {row?.user?.last_name || ""}
          </p>
        </div>
      </>
    ),
  },
  {
    field: "product_detail",
    header: "Product Details",
    accessor: (row, handleCellClick) => (
      <>
        <div
          onClick={() => handleCellClick(row, "product_detail")}
          className="cursor-pointer text-green600 hover:text-green800  w-[15rem] max-w-[20rem] "
        >
          <Description description={row?.product_detail?.name || ""} length={20} />
        </div>
      </>
    ),
  },
  {
    field: "rating",
    header: "Rating",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "user")} className="">
          <p className="w-[6rem]">
            <StarRating stars={row?.rating} />
          </p>
        </div>
      </>
    ),
  },
  {
    field: "review",
    header: "Review",
    accessor: (row, handleCellClick) => {
      return (
        <>
          <div
            onClick={() => handleCellClick(row, "review")}
            className="w-[20rem] max-w-[20rem]"
          >
            <Description description={row?.review || ""} length={40} />
          </div>
        </>
      );
    },
  },
  {
    field: "vendor_reply",
    header: "Reply Status",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "vendor_reply")} className="w-[20rem] max-w-[20rem]">
          {row?.vendor_reply ? (
            <div className="bg-gray-100 p-2 rounded">
              <Description description={row.vendor_reply} length={40} />
            </div>
          ) : (
            <span className="text-gray-400">No reply yet</span>
          )}
        </div>
      </>
    ),
  },
  {
    field: "actions",
    header: "Actions",
    accessor: (row, handleCellClick) => (
      <div className="flex ml-10 gap-2">
        <button
          className=""
          onClick={(e) => {
            e.stopPropagation();
            handleCellClick(row, "replyAction");
          }}
          title="Reply"
        >
          <FaReply />
        </button>
        {/* <button
          className=""
          onClick={(e) => {
            e.stopPropagation();
            handleCellClick(row, "hideAction");
          }}
          title="Hide Review"
        >
          <BiSolidHide />
        </button> */}
      </div>
    ),
  }
];

export const ProductsearchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

export const Productfilters = [
  {
    filterType: "Rating",
    inputName: "rating",
    options: [
      {
        name: "5",
        code: "5",
      },
      {
        name: "4",
        code: "4",
      },
      {
        name: "3",
        code: "3",
      },
      {
        name: "2",
        code: "2",
      },
      {
        name: "1",
        code: "1",
      },
    ],
  },
  {
    filterType: "Reply Status",
    inputName: "replyStatus",
    options: [
      {
        name: "With Reply",
        code: "With Reply",
      },
      {
        name: "Without Reply",
        code: "Without Reply",
      },
    ],
  },
];

export const ProductcanlenderFilter = {
  filterType: "Review Date",
  inputName: "createdAt",
  maxDate: new Date(),
};